<template>
  <div name="hrms31e-detail">
    <div  class="box">
      <div class="box-body">
        <div class="detail detail-responsive">
          <div class="form-horizontal">
            <div class="form-group margin-b-5">
              <label class="col-md-4 control-label">{{ labels['HRPM31EP1']['10'] }}</label>
              <div class="col-md-4">
                <div class="form-control readonly-field-color">{{ indexSelected.codempid }} - {{ indexSelected.desc_codempid }}</div>
              </div>
            </div>
          </div>
          <div class="form-horizontal">
            <div class="form-group margin-b-5">
              <label class="col-md-4 control-label">{{ labels['HRPM31EP1']['20'] }}</label>
              <div class="col-md-4">
                <div class="form-control readonly-field-color">{{ indexSelected.numseq }}</div>
              </div>
            </div>
          </div>
          <div class="form-horizontal">
            <div class="form-group margin-b-5">
              <label class="col-md-4 control-label">{{ labels['HRPM31EP1']['30'] }}</label>
              <div class="col-md-4">
                <div class="form-control readonly-field-color">{{ codeval }} - {{ descCodeval }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="box-tab">
      <div id="accordion">
        <div class="panel box-collapse border-color-skin" v-if="detail.tab2.table1.rows.length > 0">
          <div class="box-header with-border box-header-collapse collapsed tab-header" data-toggle="collapse" data-parent="#accordion" href="#details2">
            <h3 class="box-title">
              <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRPM31EP1']['50'] }}
            </h3>
          </div>
          <div id="details2" class="panel-collapse collapse in tab-detail">
            <div class="panel-body clear-padding">
              <div class="detail detail-responsive panel-detail-filter clearfix">

                <div class="col-md-5">
                  <div class="form-horizontal">
                    <div class="form-group margin-b-5">
                      <label class="col-md-5 control-label">{{ labels['HRPM31EP2']['10'] }}</label>
                      <div class="col-md-7">
                        <div class="form-control readonly-field-color">{{detail.tab2.detail.codform}} - {{detail.tab2.detail.desc_codform}}</div>
                      </div>
                    </div>
                  </div>

                  <div class="form-horizontal">
                    <div class="form-group margin-b-5">
                      <label class="col-md-5 control-label">{{ labels['HRPM31EP2']['80'] }}</label>
                      <div class="col-md-7">
                        <textarea class="form-control" 
                                  v-model="detail.tab2.detail.commboss"
                                  maxlength="600" 
                                  v-validate="'max:600'"
                                  data-vv-name="commboss"
                                  :has-error="errors.has('commboss')"></textarea>
                        <div class="text-error" v-show="errors.has('commboss')">{{errors.first('commboss')}}</div>
                        <div class="remark-limit-character">{{ dispLimitLabel(600) }}</div> 
                      </div>
                    </div>
                  </div>
                 <!--  <div class="box-footer">
                    <button type="button" class="btn bg-color-skin pull-left"  value=""><i class="fa fa-print"></i>{{ labels['HRPM31EP2']['15'] }}</button>
                  </div> -->
                </div>
                <div class="col-md-7">
                  <div class="col-md-12 clear-padding">
                    <div class="evaluation-wrapper">
                      <template v-for="dataGroup in detail.tab2.table1.rows">
                        <group  :labels="labels"
                                :dataGroup="dataGroup"
                                :choices="detail.tab2.table2.rows"
                                :changeChoice="changeChoice"
                                name="detail"/>
                      </template>
                    </div>
                  </div>
                  <div class="col-md-12 clear-padding">
                    <div class="evaluation-sum">
                      {{ labels['HRPM31EP2']['100'] }} {{ scorepr }}/{{ calTotalScore(detail.tab2.table1.rows) }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="panel box-collapse border-color-skin">
          <div class="box-header with-border box-header-collapse collapsed tab-header" data-toggle="collapse" data-parent="#accordion" href="#details3">
            <h3 class="box-title">
              <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRPM31EP1']['60'] }}
            </h3>
          </div>
          <div id="details3" class="panel-collapse collapse tab-detail">
            <div class="panel-body">
              <div class="detail detail-responsive ">

                <detail-search  :receivedHrms31eDetailSearch="receivedHrms31eDetailSearch"
                                :labels="labels"
                                :labelsButton="labelsButton"
                                :nowLang="nowLang"
                                :setSaveButtonDisp="setSaveButtonDisp"
                                :codempid="indexSelected.codempid"
                                :dtest="detail.tab1.dteempmt"
                                :dteen="detail.tab1.dteduepr" />

                <div class="detail-block-float detail-block-left">
                  <div class="detail-header">{{ labels['HRPM31EP3']['40'] }}</div>
                  <hrms-table :columns="tab3Table1"
                              :data="detail.tab3.table1"
                              :searchDisp="false"
                              :tablePageDisp="false" />
                </div>

                <div class="detail-block-float detail-block-right">
                  <div class="detail-header">{{ labels['HRPM31EP3']['50'] }}</div>
                  <div class="form-horizontal">
                    <div class="form-group">
                      <div class="col-xs-6 col-md-4">
                        <label >{{ labels['HRPM31EP3']['110'] }}</label>
                      </div>
                      <div class="col-xs-6 col-md-4">
                        <label>{{ labels['HRPM31EP3']['120'] }}</label>
                      </div>
                      <div class="col-xs-6 col-md-4">
                        <label>{{ labels['HRPM31EP3']['130'] }}</label>
                      </div>
                    </div>
                     </div>

                    <div class="form-horizontal">
                      <div class="form-group margin-b-5">
                        <label class="col-xs-6 col-md-3 ">{{ labels['HRPM31EP3']['140'] }}</label>
                        <div class="col-xs-6 col-md-4">
                          <div class="form-control readonly-field-color align-center">{{ detail.tab3.detail.qtytlate }}</div>
                        </div>
                        <div class="col-xs-6 col-md-4">
                          <div class="form-control readonly-field-color align-center">{{ detail.tab3.detail.qtylate }}</div>
                        </div>
                      </div>
                    </div>

                    <div class="form-horizontal">
                      <div class="form-group margin-b-5">
                        <label class="col-xs-6 col-md-3 ">{{ labels['HRPM31EP3']['150'] }}</label>
                        <div class="col-xs-6 col-md-4">
                          <div class="form-control readonly-field-color align-center">{{ detail.tab3.detail.qtytearly }}</div>
                        </div>
                        <div class="col-xs-6 col-md-4">
                          <div class="form-control readonly-field-color align-center">{{ detail.tab3.detail.qtyearly }}</div>
                        </div>
                      </div>
                    </div>
                    <div class="form-horizontal">
                      <div class="form-group margin-b-5">
                        <label class="col-xs-6 col-md-3 ">{{ labels['HRPM31EP3']['160'] }}</label>
                        <div class="col-xs-6 col-md-4">
                          <div class="form-control readonly-field-color align-center">{{ detail.tab3.detail.qtytabs }}</div>
                        </div>
                        <div class="col-xs-6 col-md-4">
                          <div class="form-control readonly-field-color align-center">{{ detail.tab3.detail.qtyabsent }}</div>
                        </div>
                      </div>
                    </div>

                    <div class="detail-header">{{ labels['HRPM31EP3']['170'] }}</div>
                    <hrms-table :columns="tab3Table2"
                                :data="detail.tab3.table2"
                                :searchDisp="false"
                                :tablePageDisp="false" />
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div class="panel box-collapse border-color-skin">
          <div class="box-header with-border box-header-collapse collapsed  tab-header" data-toggle="collapse" data-parent="#accordion" href="#details1">
            <h3 class="box-title">
              <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRPM31EP1']['40'] }}
            </h3>
          </div>
          <div id="details1" class="panel-collapse collapse tab-detail">
            <div class="panel-body">
              <div class="detail detail-responsive">
                <div class="detail-block">

                  <div class="form-horizontal">
                    <div class="form-group margin-b-5">
                      <label class="col-md-4 control-label">{{ labels['HRPM31EP1']['70'] }}</label>
                      <div class="col-md-4">
                        <div class="form-control readonly-field-color">{{ detail.tab1.desc_typproba }}</div>
                      </div>
                    </div>
                  </div>

                  <div class="form-horizontal">
                    <div class="form-group margin-b-5">
                      <label class="col-md-4 control-label">{{ labels['HRPM31EP1']['80'] }}</label>
                      <div class="col-md-4">
                        <div class="input-group margin-b-0" style="margin: 0px 0;">
                          <input class="form-control" readonly v-model="detail.tab1.qtyasg" />
                          <div class="input-group-addon" >{{ labels['HRPM31EP1']['90'] }}</div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="form-horizontal">
                    <div class="form-group margin-b-5">
                      <label class="col-md-4 control-label">{{ labels['HRPM31EP1']['100'] }}</label>
                      <div class="col-md-4">
                        <div class="input-group margin-b-0" style="margin: 0px 0;">
                          <input class="form-control" readonly v-model="detail.tab1.qtyapp" />
                          <div class="input-group-addon">{{ labels['HRPM31EP1']['110'] }}</div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="form-horizontal">
                    <div class="form-group margin-b-5">
                      <label class="col-md-4 control-label">{{ labels['HRPM31EP1']['120'] }}</label>
                      <div class="col-md-4">
                        <div class="form-control readonly-field-color">{{ setDateOutput(detail.tab1.dteempmt) }}</div>
                      </div>
                    </div>
                  </div>

                  <div class="form-horizontal">
                    <div class="form-group margin-b-5">
                      <label class="col-md-4 control-label">{{ labels['HRPM31EP1']['130'] }}</label>
                      <div class="col-md-4">
                        <div class="form-control readonly-field-color">{{ setDateOutput(detail.tab1.dteduepr) }}</div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-horizontal">
                  <div class="form-group margin-b-5">
                    <label class="col-md-2 control-label">{{ labels['HRPM31EP1']['140'] }}</label>
                    <div class="col-md-3">
                      <hrms-datepicker  v-model="detail.tab1.dteeval"
                                        v-validate="'required|date_format:DD/MM/YYYY'"
                                        data-vv-value-path="inputDate"
                                        name="dteeval"
                                        :has-error="errors.has('dteeval')" />
                      <div class="text-error" v-show="errors.has('dteeval')">{{errors.first('dteeval')}}</div>
                    </div>
                  </div>
                </div>

                <div class="form-horizontal">
                  <div class="form-group margin-b-5">
                    <label class="col-md-2 control-label">{{ labels['HRPM31EP1']['150'] }}</label>
                    <div class="col-md-3">
                      <hrms-num-input v-model="detail.tab1.scorepr"
                                      :numLength='3'
                                      data-vv-value-path="inputDate"
                                      v-validate="'required|max:6'"
                                      maxlength="6" 
                                      name="scorepr"
                                      data-vv-name="scorepr"
                                      :has-error="errors.has('scorepr')" />
                      <div class="text-error" v-show="errors.has('scorepr')">{{errors.first('scorepr')}}</div>
                    </div>
                    <!-- <div class="col-md-3">
                      <input  class="form-control text-center" v-model="detail.tab1.scorepr"
                              type="number"
                              v-validate="'required'"
                              data-vv-value-path="inputDate"
                              name="scorepr"
                              :has-error="errors.has('scorepr')" />
                      <div class="text-error" v-show="errors.has('scorepr')">{{errors.first('scorepr')}}</div>
                    </div> -->
                    <label class="col-md-2 control-label">{{ labels['HRPM31EP1']['160'] }}</label>
                    <div class="col-md-3">
                      <hrms-dropdown  v-model="detail.tab1.codrespr" :options="dropdowns.codrespr[nowLang]"
                                      v-validate="'required'"
                                      data-vv-value-path="inputDate"
                                      name="codrespr"
                                      :has-error="errors.has('codrespr')" />
                      <div class="text-error" v-show="errors.has('codrespr')">{{errors.first('codrespr')}}</div>
                    </div>
                  </div>
                </div>

                <div class="form-horizontal">
                  <div class="form-group margin-b-5">
                    <label class="col-md-2 control-label">{{ labels['HRPM31EP1']['170'] }}</label>
                    <div class="col-md-3">
                      <hrms-num-input v-model="detail.tab1.qtyexpand"
                                      :decimal=0
                                      :numLength='10'
                                      name="qtyexpand"
                                      v-validate="(detail.tab1.codrespr === 'E' ? 'required' : '')"
                                      data-vv-scope="ruleCodrespr"
                                      data-vv-value-path="inputDate"
                                      :has-error="errors.has('ruleCodrespr.qtyexpand')" />

                      <span class="text-error" v-show="errors.has('ruleCodrespr.qtyexpand')">{{ errors.first('ruleCodrespr.qtyexpand') }}</span>
                    </div>
                    <label class="col-md-2 control-label">{{ labels['HRPM31EP1']['190'] }}</label>
                    <div class="col-md-3">
                      <hrms-dropdown v-model="detail.tab1.codexemp" :options="dropdowns.codexemp[nowLang]"
                                      v-validate="validateCodexemp"
                                      data-vv-value-path="inputDate"
                                      name="codexemp"
                                      :has-error="errors.has('codexemp')" />
                      <div class="text-error" v-show="errors.has('codexemp')">{{errors.first('codexemp')}}</div>
                    </div>
                  </div>
                </div>

                <div class="form-horizontal">
                  <div class="form-group margin-b-5">
                    <label class="col-md-2 control-label">{{ labels['HRPM31EP1']['180'] }}</label>
                    <div class="col-md-8">
                      <textarea class="form-control" 
                                v-model="detail.tab1.desnote"
                                maxlength="60" 
                                v-validate="'max:60'"
                                data-vv-name="desnote"
                                :has-error="errors.has('desnote')"></textarea>
                      <div class="text-error" v-show="errors.has('desnote')">{{errors.first('desnote')}}</div>
                      <div class="remark-limit-character">{{ dispLimitLabel(60) }}</div> 
                    </div>
                  </div>
                </div>

                <div class="form-horizontal">
                  <div class="form-group margin-b-5">
                    <label class="col-md-2 control-label">{{ labels['HRPM31EP1']['200'] }}</label>
                    <div class="col-md-8 ">
                      <input type="radio" value="P" v-model="detail.tab1.flgappr" /> <span class="radio-text">{{ labels['HRPM31EP1']['210'] }}</span>
                      <input type="radio" value="C" v-model="detail.tab1.flgappr" /> <span class="radio-text">{{ labels['HRPM31EP1']['220'] }}</span>
                    </div>

                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="box-footer">
        <button type="button" class="btn bg-color-skin margin-b-10" :class="{ 'pull-right' : pcDisp }" data-toggle="modal" data-target="#hrms31e-popup" @click="togglePopupDetail()"><i class="fa fa-list-alt"></i> {{ labels['HRPM31EP1']['230'] }}</button>
        <button type="button" class="btn bg-dark-gray" @click="callBack()" value="Back"><i class="fa fa-chevron-circle-left"></i>{{ labelsButton['back'] }}</button>
        <button type="button" class="btn bg-color-skin" @click="saveParams()" v-if="flgDispSave"><i class="fa fa-check-circle"></i>{{ labelsButton['save'] }}</button>
        <button type="button" class="btn bg-red-pink" @click="callDelete()" value="Back" v-if="flgDispSave"><i class="fa fa-trash-o"></i>{{ labelsButton['delete'] }}</button>
        <button v-if="btnMailDisp && flgDispSave" type="button" class="btn bg-color-skin" @click="callSendMail()"><i class="fa fa-envelope"></i> {{ labelsButton['sendmail'] }}</button>
        <button v-else type="button" class="btn bg-color-skin-disable" :disabled="!btnMailDisp"><i class="fa fa-envelope"></i> {{ labelsButton['sendmail'] }}</button>
      </div>
    </div>

    <popup  :labels="labels"
            :nowLang="nowLang"
            :popupDetail="popupDetail"
            :receivedHrms31eDetailPopup="receivedHrms31eDetailPopup" />

  </div>
</template>

<script>
import detailSearch from 'components/hrms31e/detail_search'
import popup from 'components/hrms31e/popup'
import group from 'components/hrms31e/group'
import { numberFormat } from 'assets/js/numberFormat.js'
import { constLabels } from 'assets/js/constLabels.js'
import assetsUtils from 'assets/js/utils'

export default {
  name: 'hrms31e-detail',
  data () {
    return {
      part1: true,
      rules: {
        qtyexpand: ''
      },
      btnMailDisp: false,
      flgChangeChoice: false,
      flgDispSave: true
    }
  },
  computed: {
    validateCodexemp () {
      return this.detail.tab1.codrespr === 'N' ? 'required' : ''
    },
    scorepr () {
      let scorepr = this.calResultScore(this.detail.tab2.table1.rows)
      if (this.flgChangeChoice) {
        this.detail.tab1.scorepr = scorepr
      }
      return Number.parseFloat(scorepr).toFixed(2)
    },
    qtyasg () {
      return this.detail.tab1.qtyasg
    }
  },
  props: [ 'labels',
    'labelsButton',
    'detail',
    'popupDetail',
    'nowLang',
    'toggle',
    'postHrms31eSave',
    'postHrms31eDelete',
    'indexSelected',
    'receivedHrms31eDetailSearch',
    'receivedHrms31eDetailPopup',
    'receivedHrms31eIndex',
    'tab3Table1',
    'tab3Table2',
    'dropdowns',
    'codeval',
    'descCodeval',
    'setSaveButtonDisp',
    'pcDisp',
    'searchIndex',
    'postHrms31eSendMail'
  ],
  watch: {
    'detail.tab1.codrespr' () {
      this.rules.qtyexpand = (this.detail.tab1.codrespr === 'E') ? 'required' : ''
      this.$nextTick(() => {
        this.$validator.validateAll('ruleCodrespr').then(result => {})
      })
    },
    indexSelected () {
      this.setButtonDisp()
    },
    qtyasg () {
      this.setButtonDisp()
    }
  },
  methods: {
    setDateOutput (date) {
      return assetsUtils.getDateOutput(date)
    },
    changeChoice () {
      this.flgChangeChoice = true
    },
    dispLimitLabel (limit) {
      return constLabels('limitTo') + ' ' + limit + ' ' + constLabels('characters')
    },
    callBack () {
      this.toggle('index')
      this.btnMailDisp = false
      this.receivedHrms31eIndex(this.searchIndex)
    },
    saveParams () {
      Promise.all([
        this.clearInput(),
        this.$validator.validateAll(),
        this.$validator.validateAll('ruleCodrespr')
      ]).then(() => {
        let searchDetailParams = {
          p_codempid_query: this.indexSelected.codempid,
          p_dteduepr: this.indexSelected.dteduepr,
          p_numseq: this.indexSelected.numseq,
          p_dtest: this.indexSelected.dteoccup
        }
        let params = {
          indexSelected: this.indexSelected,
          detail: this.detail,
          codeval: this.codeval,
          searchParams: this.searchIndex,
          searchDetailParams: searchDetailParams,
          setBtnSendMail: this.setBtnSendMail
        }
        this.postHrms31eSave(params)
        this.flgChangeChoice = false
      })
      if (typeof this.errors.errors[0] !== 'undefined') {
        document.getElementsByName(this.errors.errors[0].field)[0].focus()
      }
    },
    callDelete () {
      let params = {
        p_codempid_query: this.indexSelected.codempid,
        p_dteduepr: this.indexSelected.dteduepr,
        p_numseq: this.indexSelected.numseq,
        p_dtest: this.indexSelected.dteoccup
      }
      this.postHrms31eDelete(params)
      this.btnMailDisp = false
    },
    togglePopupDetail () {
      let popupParams = {
        p_codempid: this.indexSelected.codempid,
        p_numseq: this.indexSelected.numseq,
        // p_dteeffec: '01012017',
        p_typproba: this.detail.tab1.typproba
      }
      this.receivedHrms31eDetailPopup(popupParams)
    },
    calResultScore (dataGroups) {
      return dataGroups.map((dataGroup) => {
        return parseFloat(dataGroup.qtyscor)
      }).reduce((a, b) => {
        return parseFloat(a) + parseFloat(b)
      })
    },
    calTotalScore (dataGroups) {
      return dataGroups.map((dataGroup) => {
        return numberFormat(parseFloat(dataGroup.qtyfscor))
      }).reduce((a, b) => {
        return numberFormat(parseFloat(a) + parseFloat(b))
      })
    },
    callSendMail () {
      let params = {
        p_codempid_query: this.indexSelected.codempid,
        p_dteduepr: this.indexSelected.dteduepr,
        p_numseq: this.indexSelected.numseq
      }
      this.postHrms31eSendMail(params)
    },
    setBtnSendMail () {
      if (this.detail.tab1.flgappr === 'C') {
        this.btnMailDisp = !this.btnMailDisp
      }
    },
    clearInput () {
      if (this.detail.tab1.codrespr === 'P') {
        this.detail.tab1.qtyexpand = ''
        this.detail.tab1.codexemp = ''
      } else if (this.detail.tab1.codrespr === 'N') {
        this.detail.tab1.qtyexpand = ''
      } else if (this.detail.tab1.codrespr === 'E') {
        this.detail.tab1.codexemp = ''
      }
    },
    setButtonDisp () {
      this.flgDispSave = (this.indexSelected.flgedit === 'Y')
      if (this.indexSelected.numseq === this.detail.tab1.qtyasg) {
        this.flgDispSave = true
      }
    }
  },
  components: {
    detailSearch,
    popup,
    group
  }
}
</script>



// WEBPACK FOOTER //
// detail.vue?5904b218